import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { CreditCard, CheckCircle2, Clock, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export const StripeConnectCard = () => {
  const [busy, setBusy] = useState(false);
  const { data: status, refetch } = useQuery({
    queryKey: ["stripe-connect-status"],
    queryFn: async () => (await api.get("/stripe/connect/status")).data,
  });

  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/stripe/connect/onboard", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  const active = status?.charges_enabled;
  const pending = status?.connected && !status?.charges_enabled;

  return (
    <div className="bg-white rounded-xl border border-black/5 shadow-sm p-5 mt-4" data-testid="stripe-connect-card">
      <div className="flex items-center gap-2 mb-1">
        <CreditCard className="h-5 w-5 text-[#635BFF]" />
        <h3 className="font-bold text-[#1A1A1A]">Paiement par carte (Stripe)</h3>
      </div>
      <p className="text-sm text-[#5C574F] mb-4">
        Connectez votre compte Stripe pour accepter les cartes bancaires. Les paiements arrivent directement chez vous,
        la commission plateforme de 2,5 % est prélevée automatiquement.
      </p>

      {active && (
        <div data-testid="stripe-status-active" className="flex items-start gap-2 rounded-lg bg-[#E8F5EE] border border-[#1B4332]/15 p-3">
          <CheckCircle2 className="h-5 w-5 text-[#1B4332] shrink-0 mt-0.5" />
          <div className="text-sm text-[#1B4332]">
            <span className="font-semibold">Compte Stripe actif ✅</span><br />
            Vos clients peuvent payer par carte. La commission de 2,5 % est prélevée automatiquement.
          </div>
        </div>
      )}

      {pending && (
        <div className="space-y-3">
          <div data-testid="stripe-status-pending" className="flex items-start gap-2 rounded-lg bg-[#FFF4E5] border border-[#E85D04]/20 p-3">
            <Clock className="h-5 w-5 text-[#E85D04] shrink-0 mt-0.5" />
            <div className="text-sm text-[#5C574F]">
              <span className="font-semibold text-[#E85D04]">Inscription à finaliser</span><br />
              Votre compte Stripe est créé mais la vérification n'est pas terminée. Finalisez-la pour activer les paiements carte.
            </div>
          </div>
          <button data-testid="stripe-finish-btn" onClick={connect} disabled={busy}
            className="w-full h-11 rounded-xl bg-[#635BFF] text-white font-semibold text-sm flex items-center justify-center gap-2 hover:bg-[#524ae0] transition-colors disabled:opacity-60">
            <ExternalLink className="h-4 w-4" /> {busy ? "Redirection…" : "Finaliser mon inscription Stripe"}
          </button>
        </div>
      )}

      {!status?.connected && (
        <button data-testid="stripe-connect-btn" onClick={connect} disabled={busy}
          className="w-full h-11 rounded-xl bg-[#635BFF] text-white font-semibold text-sm flex items-center justify-center gap-2 hover:bg-[#524ae0] transition-colors disabled:opacity-60">
          <CreditCard className="h-4 w-4" /> {busy ? "Redirection…" : "Connecter mon compte Stripe"}
        </button>
      )}
    </div>
  );
};
